import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, Input, output, signal} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventAlarmTemplate} from '../../event-alarm.model';
import {TooltipComponent} from '@brunata-angular/ui';

@Component({
    selector: 'app-select-template-or-custom-event-alarm',
    standalone: true,
    imports: [CommonModule, TranslatePipe, TooltipComponent],
    templateUrl: './select-template-or-custom-event-alarm.component.html',
    styleUrl: './select-template-or-custom-event-alarm.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectTemplateOrCustomEventAlarmComponent {
    @Input() set templates(eventAlarmTemplates: EventAlarmTemplate[]) {
        this.templatesSignal.set(eventAlarmTemplates);
    }

    templateSelected = output<EventAlarmTemplate>();

    private readonly activeModal = inject(NgbActiveModal);

    readonly templatesSignal = signal<EventAlarmTemplate[]>([]);

    selectTemplate(template: EventAlarmTemplate): void {
        this.templateSelected.emit(template);
        this.close();
    }

    close(): void {
        this.activeModal.close();
    }
}
